document.querySelectorAll('.menu-navigation[role="tablist"]').forEach(tablist => {
	const tabs = [...tablist.querySelectorAll('[role="tab"]')];

	const activate = (tab, { focus = true } = {}) => {
		tabs.forEach(t => {
			const selected = t === tab;
			t.setAttribute('aria-selected', selected);
			t.tabIndex = selected ? 0 : -1;

			const panel = document.getElementById(t.getAttribute('aria-controls'));
			if (panel) panel.hidden = !selected;
		});
		if (focus) tab.focus();
	};

	tabs.forEach((tab, i) => {
		tab.addEventListener('click', () => activate(tab, { focus: false }));

		tab.addEventListener('keydown', (e) => {
			let index = null;
			if (e.key === 'ArrowRight' || e.key === 'ArrowDown') index = (i + 1) % tabs.length;
			else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') index = (i - 1 + tabs.length) % tabs.length;
			else if (e.key === 'Home') index = 0;
			else if (e.key === 'End') index = tabs.length - 1;

			if (index === null) return;
			e.preventDefault();
			activate(tabs[index]);
		});
	});
});
